import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import Select from 'components/tags/Select/index.jsx';
import UserAvatar from 'components/user/UserAvatar/index.jsx';
import userGroupSvg from 'images/SVG/usergroup.svg';
import phone from './iPhone-shell.png';
import messages from './messages.js';

const Wrapper = styled.div`
  width: 307px;
  max-width: calc(100vw - 50px);
  height: 640px;
  background: url(${phone}) no-repeat;
  background-size: contain;
  padding: 68px 14px;
  @media screen and (min-width: ${(props) => props.theme.screenSmMin}) {
    padding: 77px 16px;
  }
`;

const Logo = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 20%;
  margin-right: 10px;
  background: #fff;
`;

const Header = styled.div`
  background-color: ${(p) => p.color};
  height: 50px;
  color: #fff;
  & > * {
    transform: scale(0.7);
  }
`;

const Content = styled.div`
  font-size: small;
  .form-control {
    font-size: small;
    color: ${(p) => p.color};
  }
`;

const Banner = styled.div`
  background: url(${(p) => p.url});
  background-size: cover;
  height: 120px;
  padding: 40px 10px 20px;
  display: flex;
  color: #fff;
`;

function Preview(props) {
  const user = useCurrentRole();
  const { name, logo, color, backgroundImage, tagLine, className } = props;
  const options = [{ value: 1, label: messages.filterAll }];
  const template = (
    <Wrapper className={className}>
      <Header color={color} className="d-flex justify-content-center align-items-center">
        <UserAvatar user={user} withRole bsSize="base" />
      </Header>
      <Banner url={backgroundImage}>
        <Logo src={logo || userGroupSvg} />
        <div>
          <h4 className="mt-0 mb-1 fs-5 text-start">{name}</h4>
          {tagLine}
        </div>
      </Banner>
      <Content color={color}>
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-baseline">
            <Select value={options[0].value} options={options} className="w-auto" disabled onChange={() => {}} />
            <span className="text-primary"><FormattedMessage {...messages.myGroups} /></span>
          </div>
        </div>
      </Content>
    </Wrapper>
  );
  return template;
}

Preview.propTypes = {
  name: PropTypes.string,
  logo: PropTypes.string,
  color: PropTypes.string,
  backgroundImage: PropTypes.string,
  tagLine: PropTypes.string,
  className: PropTypes.string,
};

export default Preview;
